import { formatDate } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { OtherMeidcalProfile, languages } from 'src/app/models/Doctorprofile';
import { ErrorModel, PromiseResult, ServerError } from 'src/app/models/PromiseResult';
import { OthermedicalregistrationService } from 'src/app/services/othermedicalregistration.service';

@Component({
  selector: 'app-other-medical-profe-shared-profile',
  templateUrl: './other-medical-profe-shared-profile.component.html',
  styleUrls: ['./other-medical-profe-shared-profile.component.css','../../../../assets/css/custom-egd.css']
})
@TraceClassDecorator()
export class OtherMedicalProfeSharedProfileComponent implements OnInit {

  constructor(private readonly othermedicalregistrationService:OthermedicalregistrationService) {
    this.posting = false;
}
response: PromiseResult;
error: ErrorModel;
serverError: ServerError;
posting: boolean;
profile:OtherMeidcalProfile=null;
// langs:languages[]=[];

@Input('user_guid')
private readonly  user_guid:string=null;

async ngOnInit(): Promise<void> {
    this.response={
        success:null,
        error:null,
        data:null
    };
    this.serverError={
        statusCode:null,
        error:null,
        message:null
    }
    if(this.user_guid==null){
        this.response={
            success:false,
            error:{
                code:"",
                message:"User guid is necessary"
            },
            data:null
        }
    }
    if(this.user_guid!=null)  await this.GetProfile();
}
private async ResetResultModels():Promise<void>{
    this.response={
        success:null,
        error:null,
        data:null
    };
    this.serverError={
        statusCode:null,
        error:null,
        message:null
    }
}

private async GetProfile():Promise<void>{
    await this.ResetResultModels();
    this.posting=true;
    await this.othermedicalregistrationService.getOtherProfessionsProfileData(this.user_guid).toPromise().then((result:any)=>{
        this.response=result;
        // this.langs=result.languages;

        if(result.success){
            this.profile=result.data;
        }
        this.posting=false;
    }).catch((error:HttpErrorResponse)=>{
        this.serverError=error.error;
        this.response.success=false;
        this.posting=false;
    })
}

FormatDates(date:string | Date):string{
    return formatDate(date, 'medium', 'en-us');
}

}
